import _ from "lodash";
import React, { useState, Fragment, memo, useRef } from "react";
import I18nHOC from "UIComponents/I18nHOC";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";
import TagSnpModalV2 from "AppComponents/TagSnpModalV2";
import TagSnpModalV4 from "AppComponents/TagSnpModalV4";
import ACLStore from "lib/aclStore";
import { ENABLE_AUTH_AND_EVAL_REVAMP } from "Constants/permissionConstants";
import classes from "./FeedsContainer.scss";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";

import classNames from "classnames";
import LibraryItem from "../LibraryItem";
import SmallLibraryItem from "../SmallLibraryItem";
import { checkTermsExistsForCurrentCurriculumProgram } from "modules/Services";
import { EVIDENCE_TYPE_ASSESSMENT } from "Constants/stringConstants";
import getEvaluationCyclesGraphql from "SnP_v2/modules/EnhanceQueries/getEvaluationCyclesGraphql";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { getLELibraryLabelsMemoize } from "UnitPlans/modules/Utils";
import { EmptyState } from "@toddle-edu/ds-web";
import { LEIllustraton, NoAssignmentIllustration } from "@toddle-edu/ds-theme";

const emptyStateSubtitleStyle = {
  maxWidth: "237px",
  lineHeight: "24px",
};

const FeedsContainer = memo(props => {
  const [tagAssessmentId, updateTagAssessmentId] = useState(false);

  const onCardClicked = ({ id, mode = "view" }) => {
    props.onCardClicked({ id: id, mode });
  };

  const onPrintClick = item => {
    props.onPrintClick(item.id);
  };

  const renderItems = () => {
    const {
      list,
      readOnly,
      size,
      curriculumType,
      onDeleteClick,
      onDuplicateClick,
      onAssignToStudentClick,
      totalNewSnpCycles,
      checkTermsExistsForCurrentCurriculumProgram,
      isDragEnabled,
      onChangeTaskTypeClick,
      testId,
    } = props;

    const isTermsExists = checkTermsExistsForCurrentCurriculumProgram();
    return _.map(list, (item, index) => {
      const draggableContainerKey = `container:${item.id}`;
      const libraryItemKey = `item:${item.id}`;

      return size == "small" ? (
        <Draggable
          key={draggableContainerKey}
          draggableId={`RESOURCE_ITEM:ASSESSMENT:${item.id}`}
          index={index}
          isDragDisabled={!isDragEnabled}
        >
          {(provided, snapshot) => (
            <SmallLibraryItem
              innerRef={provided.innerRef}
              snapshot={snapshot}
              provided={provided}
              key={libraryItemKey}
              item={item}
              curriculumType={curriculumType}
              onCardClicked={onCardClicked}
              onDeleteClick={onDeleteClick}
              onDuplicateClick={onDuplicateClick}
              onPrintClick={onPrintClick}
              onAssignToStudentClick={onAssignToStudentClick}
              readOnly={readOnly}
              updateTagAssessmentId={updateTagAssessmentId}
              totalNewSnpCycles={totalNewSnpCycles}
              isTermsExists={isTermsExists}
              onChangeTaskTypeClick={onChangeTaskTypeClick}
              testId={testId}
            />
          )}
        </Draggable>
      ) : (
        <LibraryItem
          key={item.id}
          item={item}
          onCardClicked={onCardClicked}
          onDeleteClick={onDeleteClick}
          onDuplicateClick={onDuplicateClick}
          onPrintClick={onPrintClick}
          readOnly={readOnly}
        />
      );
    });
  };

  const renderNoDataComp = () => {
    const {
      size,
      assessmentTypeDetail,
      t,
      filters: { searchText = "" },
      assessmentType,
      i18n,
    } = props;

    if (size == "small") {
      return (
        <div className={classes.noSearchContainer}>
          <div className={classes.noSearchTopContainer}>
            <EmptyState
              illustration={
                assessmentType === "LEARNING_ENGAGEMENT"
                  ? LEIllustraton
                  : NoAssignmentIllustration
              }
              subtitle={
                _.size(searchText) > 0
                  ? t("common:no_search_msg_label", { label: searchText })
                  : getLELibraryLabelsMemoize({
                      assessmentType,
                      assessmentTypeDetail,
                      labelType: "emptyText",
                      t,
                      lng: _.get(i18n, "language", "en"),
                    })
              }
              subtitleStyle={emptyStateSubtitleStyle}
            />
          </div>
        </div>
      );
    }

    return null;
  };

  const getTagSnpModalV2Element = () => {
    const { list, curriculumProgramId } = props;
    const tagAssessmentItem = _.find(list, item => item.id === tagAssessmentId);

    const itemTitle = _.get(tagAssessmentItem, "title.value", "");

    const thumbnailData = _.get(tagAssessmentItem, "image", {});

    const taggedPractices = _.get(tagAssessmentItem, "taggedPractices", []);

    const closeModal = () => updateTagAssessmentId("");

    const isAuthAndEvalRevampEnabled = ACLStore.can(
      ENABLE_AUTH_AND_EVAL_REVAMP
    );

    return tagAssessmentId ? (
      isAuthAndEvalRevampEnabled ? (
        <TagSnpModalV4
          curriculumProgramId={curriculumProgramId}
          itemId={tagAssessmentId}
          itemTitle={itemTitle}
          taggedPractices={taggedPractices}
          closeModal={closeModal}
          itemType={EVIDENCE_TYPE_ASSESSMENT}
        />
      ) : (
        <TagSnpModalV2
          curriculumProgramId={curriculumProgramId}
          itemId={tagAssessmentId}
          itemTitle={itemTitle}
          thumbnailData={thumbnailData}
          taggedPractices={taggedPractices}
          closeModal={closeModal}
          itemType={EVIDENCE_TYPE_ASSESSMENT}
        />
      )
    ) : null;
  };

  const { list, size, isLoading, isUnitFlowRevamp } = props;

  const itemsContainer = classNames({
    [classes.itemsContainer]: true,
    [classes.itemsContainerSmall]: size == "small",
    [classes.itemsContainerRevamp]: isUnitFlowRevamp,
  });

  const listContainerRef = useRef(null);

  return (
    <Fragment>
      <Droppable droppableId="RESOURCE_LIST" isDropDisabled={true}>
        {(provided, snapshot) => (
          <div
            className={itemsContainer}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {isLoading ? (
              <Loading />
            ) : _.size(list) > 0 ? (
              <KeyboardNavigableList
                shouldPreventDefault
                listContainerRef={listContainerRef}
              >
                <div ref={listContainerRef}>
                  {renderItems()}
                  {provided.placeholder}
                </div>
              </KeyboardNavigableList>
            ) : (
              renderNoDataComp()
            )}
          </div>
        )}
      </Droppable>
      {getTagSnpModalV2Element()}
    </Fragment>
  );
});

FeedsContainer.displayName = FeedsContainer;

FeedsContainer.defaultProps = {};

const mapStateToProps = (state, ownProps) => {
  const filters = _.get(state, "assessment.filters", {});
  const organizationId = _.get(state, "login.userInfo.org_id", "");
  const curriculumType = ownProps.curriculumType;

  const organizationCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  const curriculumProgramId = _.get(
    _.find(
      organizationCurriculumPrograms,
      ({ type }) => type === curriculumType
    ),
    "id",
    ""
  );

  return {
    filters,
    organizationId,
    curriculumProgramId,
    loginActiveTab: _.get(state, "login.activeTab", ""),
  };
};

const mapActionCreators = {
  checkTermsExistsForCurrentCurriculumProgram,
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators),
  getEvaluationCyclesGraphql,
  withLoader
)(FeedsContainer);

FeedsContainer.defaultProps = {
  totalNewSnpCycles: 0,
  isDragEnabled: true,
};
